const Footer: React.FC = () => (
  <footer className="bg-gray-950 text-white py-8 text-center">
    <div className="max-w-7xl mx-auto px-6">
      <p>&copy; 2024 Menu Master. Todos os direitos reservados.</p>
    </div>
  </footer>
);
export default Footer;